






import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Frame extends Vue {
    get show() {
        if (process.env.VUE_APP_BRAND === 'GT') {
            return true;
        }
        return false;
    }
}
